import React, { useState } from "react";
import { Marker } from "@react-google-maps/api";
import theme from "../../../styles/theme";
import InfoWindowPosicao from "./InfoWindowPosicao";
import Icon from "../../../assets/m-efetivado-big.png";

const CheckpointsEfetivados = ({ points, isEndUser }) => {
  const [clicked, setClicked] = useState(null);

  return (
    <>
      {points.map((p, i) => {
        return (
          <Marker
            key={p.id}
            position={p.longitudeLatitude}
            icon={Icon}
            clickable={true}
            onClick={() => setClicked(p)}
          />
        );
      })}
      <InfoWindowPosicao
        isEndUser={isEndUser}
        item={clicked}
        handleClose={() => setClicked(null)}
        canDelete={false}
      />
    </>
  );
};

export default CheckpointsEfetivados;
